import { render, staticRenderFns } from "./Frontpage.vue?vue&type=template&id=6fc5a039&"
import script from "./Frontpage.vue?vue&type=script&lang=ts&"
export * from "./Frontpage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports